<template>
    <aside>
        <div>
            <div class="titulo margem efeito">
                <div class="m-icone"><a href="#" class="icone-menu" title="Menu"
                        onclick="document.getElementById('main').classList.toggle('esconde');return false"></a></div>
            </div>
            <div class="separador margem">
                <div class="m-icone" v-if="podeAcessarGestao">
                    <a class="icone-app" :class="{ ativo: abaAtiva === 1 }" @click="selecionarAba(1)"></a>
                    <a class="icone-alvo" :class="{ ativo: abaAtiva === 2 }" @click="selecionarAba(2)"></a>
                </div>
            </div>
            <nav class="nav-maior separador" v-if="abaAtiva === 2">
                <div class="separador">
                    <router-link
                        v-if="isAuditor"
                        to="/gestao"
                        :class="{ ativo: $route.path === '/gestao' }"
                    > Gestão de Projetos </router-link>
                    <router-link v-if="isAuditor" to="/gestao/dashboard-projetos" active-class="ativo"> Dashboard de Projetos </router-link>
                    <router-link
                        v-if="isAuditor"
                        to="/gestao/portfolio-projetos"
                        :class="{ ativo: isRotaPortfolio }"
                    > Portfólio de Projetos </router-link>
                    <router-link v-if="isAuditor" to="/gestao-mudancas" active-class="ativo"> Gestão de Mudanças </router-link>
                    <router-link v-if="isAuditor" to="/gestao-logs-projeto" active-class="ativo"> Logs de Projeto </router-link>
                    <router-link v-if="podeAcessarGestaoIa" to="/gestao/ia" active-class="ativo"> Gestão de IA </router-link>
                    <router-link v-if="podeLancarDespesa" to="/gestao-despesas-projeto" active-class="ativo">
                        Lançamento Despesa Projeto
                    </router-link>
                </div>
            </nav>
            <nav class="nav-maior separador" v-if="abaAtiva === 1">
                <div class="separador">
                    <router-link to="/" active-class="ativo" style="padding-right: 3px;">
                        <div style="display: flex;" class="alinha-v"><span @click="limparStorage"
                                style="white-space: nowrap">Tarefas</span>
                            <span style="margin-left: 5px;" class="hPoints bg-alerta"
                                @click="filtrarTarefas('pendente')"> {{ tarefas[0] }}</span>
                            <span class="hPoints bg-ok" @click="filtrarTarefas('emAndamento')">{{ tarefas[1] }}</span>
                            <span class="hPoints bg-erro" @click="filtrarTarefas('atrasada')">{{ tarefas[2] }}</span>
                        </div>
                    </router-link>
                </div>
                <div class="separador">
                    <router-link to="/reunioes-google" active-class="ativo">Reuniões Google</router-link>
                    <router-link to="/gestao-entregas" active-class="ativo"> Gestão de pacotes de trabalho </router-link>
                </div>
                <!-- <div class="separador">
                    <router-link to="/indicadores" active-class="ativo">Indicadores</router-link>
                </div> -->
                <div class="separador">
                    <router-link to="/Programas/controle" active-class="ativo"
                        v-if="funcionalidades.includes(109)">Programas - PRO</router-link>
                    <router-link to="/projetos/0" @click="verProjetos" active-class="ativo">Projeto - PRJ</router-link>
                    <router-link to="/protocolos/5" active-class="ativo">Plano de Ação - PLA</router-link>
                    <!-- <router-link to="/PAP" active-class="ativo">Plano de Alteração de Produto - PAP
                        (Antigo)</router-link> -->
                </div>
                <div class="separador">
                    <router-link to="/protocolos/8" active-class="ativo">Plano de Alteração de Produto -
                        PAP</router-link>
                    <!-- <router-link to="/os_tablets" :class="{ ativo: $route.path.startsWith('/os_tablets') }">OS
                        Tablets</router-link> -->
                    <router-link to="/protocolos/4" active-class="ativo">Ordem de Serviço - OS</router-link>
                    <router-link to="/protocolos/1" active-class="ativo">Tratativa de Não Conformidade -
                        TNC</router-link>
                    <router-link to="/protocolos/3" active-class="ativo">Resposta de Avaliação de Produto -
                        RAP</router-link>
                </div>
                <div class="separador">
                    <router-link to="/rotina" active-class="ativo">Rotina</router-link>
                </div>
                <div class="separador" v-if="funcionalidades.includes(117)">
                    <router-link to="/agenda" active-class="ativo">Agenda de reuniões</router-link>
                    <router-link to="/temas" active-class="ativo">Cadastro de temas agendados</router-link>
                </div>
                <div class="separador">
                    <router-link to="/PA/Controle" active-class="ativo"> Plano de Ação - PLA (Antigo)</router-link>
                    <router-link to="/PAP" active-class="ativo"> Plano de Alteração de Produto - PAP
                        (Antigo)</router-link>
                </div>
            </nav>
        </div>
    </aside>
</template>
<script>
import { dataParaInput } from "@/utils/date";
import { useApiError } from "@/composables/useApiError";
import { getPermissao } from "@/services/permissao-service";
import { listarTarefasUsuario } from "@/services/serviceGestaoTarefas";
import { canAccessAiGovernance } from "@/utils/ai-governance";
import { sso } from "roboflex-thalamus-sso-lib";

export default {
    name: "NovoMenuLateral",

    setup() {
        const { handleError } = useApiError();
        return { handleApiError: handleError };
    },

    data() {
        return {
            sgp: '',
            tipo: null,
            funcionalidades: [],
            idUsuario: null,
            abaAtiva: 1,

            tipoProtocolo: sessionStorage.getItem('tipoProtocolo'),
            tarefas: ['-', '-', '-'],
        }
    },

    computed: {
        isAuditor() {
            return this.funcionalidades.includes(116)
        },
        podeLancarDespesa() {
            return this.isAuditor || this.funcionalidades.includes(269)
        },
        podeAcessarGestaoIa() {
            return canAccessAiGovernance(this.funcionalidades)
        },
        podeAcessarGestao() {
            return this.isAuditor || this.podeLancarDespesa || this.podeAcessarGestaoIa
        },
        isRotaPortfolio() {
            const p = this.$route.path
            return p.startsWith('/gestao/portfolio-projetos')
                || p.startsWith('/gestao/portfolio-documentacao')
        },
    },

    watch: {
        '$route.path': {
            immediate: true,
            handler(path) {
                this.sincronizarAbaPelaRota(path)
            },
        },
    },

    async created() {
        const usuarioLogado = sso.getUsuarioLogado()
        this.idUsuario = usuarioLogado.id
        this.funcionalidades = await getPermissao()
        this.sincronizarAbaPelaRota(this.$route.path)
        try {
            const data = await listarTarefasUsuario({
                dtFim: "",
                idUser: [{ valor: this.idUsuario }],
                statusProjetoPa: [{ valor: "Aprovado" }, { valor: "Em andamento" }, { valor: "Concluído" }],
                statusTarefa: [{ valor: "Pendente" }, { valor: "Em andamento" }],
            });
            let statusPendente = 0;
            let statusEmAndamento = 0;
            let atrasadas = 0;
            const hoje = dataParaInput(new Date().toISOString());
            data.forEach((tarefa) => {
                if (tarefa.status === "Pendente") statusPendente++;
                if (tarefa.status?.startsWith("Em andamento")) statusEmAndamento++;
                if (tarefa.dtFim < hoje && tarefa.status !== "Concluído" && tarefa.status !== "Cancelada") atrasadas++;
            });
            this.tarefas = [statusPendente, statusEmAndamento, atrasadas];
        } catch (error) {
            this.handleApiError(error);
        }
    },

    methods: {
        ehRotaMenuGestao(path) {
            return path === '/gestao'
                || path.startsWith('/gestao/')
                || path.startsWith('/gestao-mudancas')
                || path.startsWith('/gestao-logs-projeto')
                || path.startsWith('/gestao-despesas-projeto')
        },
        sincronizarAbaPelaRota(path) {
            if (!this.podeAcessarGestao) {
                this.abaAtiva = 1
                return
            }
            this.abaAtiva = this.ehRotaMenuGestao(path) ? 2 : 1
        },
        selecionarAba(aba) {
            this.abaAtiva = aba
        },
        limparStorage() {
            sessionStorage.removeItem('storageFiltrarTarefas')
            if (this.$route.path === '/') {
                window.location.reload();
            }
        },
        filtrarTarefas(item) {
            sessionStorage.setItem('storageFiltrarTarefas', item);
            if (this.$route.path === '/') {
                window.location.reload();
            }
        },
        verProjetos() {
            this.$router.push({ name: "controleDeProjetos", params: { id: 0 } })
        },

    },

};
</script>
<style scoped>
.hPoints {
    border-radius: 6px;
    font-size: 12px;
    width: 1.5rem;
    height: 1.5rem;
}

.hPoints:hover {
    transition: all 100ms linear;
    transform: scale(1.2);
}
</style>